







































import Vue from 'vue';
import * as api from '@/api';
import HeaderNews from './header/HeaderNews.vue';
import HeaderVs from './header/HeaderVs.vue';

export default Vue.extend({
    components: {
        HeaderNews,
        HeaderVs,
    },
    watch: {
        user: {
            handler(val) {
                if (val) {
                    this.$store.dispatch('getUnreadCount');
                    this.$store.dispatch('getProductCompareList');
                }
            },
            immediate: true,
        },
    },
    computed: {
        unreadCount() {
            return this.$store.state.unreadCount;
        },
        user(): api.User {
            return this.$store.state.user;
        },
        compareListCount(): number {
            return this.$store.state.compareProductList.length;
        },
    },
    methods: {
        async login() {
            await api.isLogined();
        },
        async toUser() {
            const isLoginRes = await api.isLogined();
            if (!api.error(isLoginRes)) {
                this.$router.push({ path: '/user/collect' });
            }
        },
    },
});
